module.exports = __webpack_public_path__ + "img/canvas_top.1fa1674c.png";